(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["qk-collection-refine"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('qk-collection-refine')) {
  customElements.define('qk-collection-refine', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      this.addEventListener('click', event => {
        const link = event.target.closest('a');
        if (!link || !this.contains(link)) return;
        const target = new URL(link.href);
        const current = new URL(location.href);
        target.search = current.search;
        target.searchParams.delete('page');
        target.hash = '';
        link.href = target.toString();
      }, { signal: this.controller.signal });
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["qk-plus-heading"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('qk-plus-heading')) {
  customElements.define('qk-plus-heading', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.phase === 'done') return;
      this.controller?.abort();
      this.observer?.disconnect();
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      if (this.motion.matches || !('IntersectionObserver' in window)) { this.finish(); return; }
      this.dataset.phase = 'ready';
      this.motion.addEventListener('change', event => { if (event.matches) this.finish(); }, { signal });
      this.addEventListener('animationend', event => { if (event.animationName === 'qk-plus-final') this.finish(); }, { signal });
      this.observer = new IntersectionObserver(entries => {
        if (!entries.some(entry => entry.isIntersecting && entry.intersectionRatio >= 0.5)) return;
        this.dataset.phase = 'playing';
        this.observer.disconnect();
      }, { threshold: 0.5 });
      this.observer.observe(this.closest('h2') || this);
    }
    finish() {
      this.dataset.phase = 'done';
      this.observer?.disconnect();
      this.controller?.abort();
    }
    disconnectedCallback() { this.finish(); }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["qk-product-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('qk-lazy-gallery')) {
  customElements.define('qk-lazy-gallery', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      if (this.dataset.quickView === 'true') return;
      const scroller = this.querySelector('slideshow-slides');
      if (!scroller) return;
      const slides = [...scroller.querySelectorAll('slideshow-slide')];
      this.controller = new AbortController();
      const { signal } = this.controller;
      const quickView = this.dataset.quickView === 'true';
      const load = (index, priority = 'low') => {
        const template = slides[index]?.querySelector('template[data-qk-slide-image]');
        if (!template) return;
        const fragment = template.content.cloneNode(true);
        fragment.querySelectorAll('img').forEach(img => {
          img.loading = 'eager';
          img.fetchPriority = priority;
        });
        template.replaceWith(fragment);
      };
      const current = () => {
        const center = scroller.getBoundingClientRect().left + scroller.clientWidth / 2;
        let index = 0, distance = Infinity;
        slides.forEach((slide, i) => {
          const rect = slide.getBoundingClientRect();
          const delta = Math.abs(rect.left + rect.width / 2 - center);
          if (delta < distance) { distance = delta; index = i; }
        });
        return index;
      };
      const warm = (index, ahead) => {
        load(index, 'auto');
        for (let n = 1; n <= ahead; n++) load(index + n);
      };
      let started = false;
      const start = () => {
        if (started) return;
        started = true;
        const first = slides[0]?.querySelector('img');
        const ready = () => warm(current(), quickView ? 2 : 1);
        if (!first || first.complete) ready();
        else {
          first.addEventListener('load', ready, { once: true, signal });
          first.addEventListener('error', ready, { once: true, signal });
        }
      };
      if (quickView) start();
      else if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) {
            start();
            this.observer.disconnect();
          }
        }, { threshold: 0.01 });
        this.observer.observe(this);
      } else start();
      this.addEventListener('pointerdown', () => warm(current(), 2), { passive: true, signal });
      this.addEventListener('focusin', () => warm(current(), 2), { signal });
      this.addEventListener('click', event => {
        const button = event.target.closest('.qk-gallery-dots button');
        if (!button) return;
        const index = [...this.querySelectorAll('.qk-gallery-dots button')].indexOf(button);
        if (index >= 0) warm(index, quickView ? 2 : 1);
      }, { capture: true, signal });
      scroller.addEventListener('scroll', () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = 0;
          warm(current(), quickView ? 2 : 1);
        });
      }, { passive: true, signal });
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.controller?.abort();
      cancelAnimationFrame(this.frame);
      this.frame = 0;
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["qk-retired-bundle"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('qk-return-to-shop')) {
  customElements.define('qk-return-to-shop', class extends HTMLElement {
    connectedCallback() {
      if (!window.Shopify?.designMode) window.location.replace(this.dataset.url);
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["qk-shopping"] && !Shopify.designMode) return;
  try {
    if (!window.qkShoppingInstalled) {
  window.qkShoppingInstalled = true;
  let copy;
  const text = key => {
    if (!copy) { try { copy = JSON.parse(document.getElementById('QkShoppingCopy').textContent); } catch { copy = {}; } }
    return copy[key] || '';
  };
  let dialog, content, opener, request, productURL, gesture, blockedCard, blockedUntil = 0;
  const close = () => {
    request?.abort();
    if (dialog?.open) dialog.close();
  };
  const ensureDialog = () => {
    if (dialog) return;
    dialog = document.createElement('dialog');
    dialog.className = 'qk-quick-view';
    dialog.setAttribute('aria-label',text('quick_view'));
    const closeButton = document.createElement('button');
    closeButton.type = 'button';
    closeButton.className = 'qk-quick-view__close';
    closeButton.setAttribute('aria-label',text('close'));
    closeButton.textContent = '×';
    closeButton.addEventListener('click',close);
    content = document.createElement('div');
    content.className = 'qk-quick-view__content';
    dialog.append(closeButton,content);
    document.body.append(dialog);
    dialog.addEventListener('close',() => {
      request?.abort();
      document.documentElement.classList.remove('qk-quick-view-open');
      if (opener?.isConnected) opener.focus({preventScroll:true});
    });
    dialog.addEventListener('click',event => { if (event.target === dialog) { const r = dialog.getBoundingClientRect(); if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) close(); } });
  };
  const loadProduct = async (url, changingVariant = false) => {
    request?.abort();
    const controller = new AbortController(); request = controller;
    const endpoint = new URL(url,location.origin);
    endpoint.searchParams.set('section_id','qk-quick-view');
    content.setAttribute('aria-busy','true');
    content.querySelectorAll('[data-qk-add-form] button').forEach(button => { button.disabled = true; });
    try {
      const response = await fetch(endpoint,{signal:controller.signal});
      if (!response.ok) throw new Error('Product request failed');
      const parsed = new DOMParser().parseFromString(await response.text(),'text/html');
      const product = parsed.querySelector('[data-qk-quick-view-product]');
      if (!product) throw new Error('Product unavailable');
      if (controller.signal.aborted) return;
      content.replaceChildren(product);
      dialog.setAttribute('aria-labelledby','QkQuickViewTitle');
      if (changingVariant) content.querySelector('[data-qk-variant]')?.focus({preventScroll:true});
      else content.scrollTop = 0;
    } catch (error) {
      if (error.name === 'AbortError') return;
      const message = document.createElement('p'); message.textContent = text('load_error');
      const retry = document.createElement('button'); retry.type = 'button'; retry.className = 'qk-quick-view__retry'; retry.textContent = text('retry'); retry.addEventListener('click',() => loadProduct(url,changingVariant));
      const details = document.createElement('a'); details.href = url; details.textContent = text('full_details');
      const box = document.createElement('div'); box.className = 'qk-quick-view__message'; box.append(message,retry,details); content.replaceChildren(box);
    } finally { if (request === controller) content.removeAttribute('aria-busy'); }
  };
  const openProduct = (url, trigger) => {
    ensureDialog(); opener = trigger; productURL = url;
    dialog.removeAttribute('aria-labelledby');
    const loading = document.createElement('p'); loading.className = 'qk-quick-view__message'; loading.setAttribute('role','status'); loading.textContent = text('loading'); content.replaceChildren(loading);
    document.documentElement.classList.add('qk-quick-view-open');
    if (!dialog.open) dialog.showModal();
    loadProduct(url);
  };
  document.addEventListener('pointerdown',event => {
    const card = event.target.closest?.('.qk-collections__card,product-card');
    if (card && !event.target.closest('button,input,select')) gesture = {card,x:event.clientX,y:event.clientY,moved:false};
    else gesture = null;
  },true);
  document.addEventListener('pointermove',event => {
    if (gesture && (Math.abs(event.clientX-gesture.x)>8 || Math.abs(event.clientY-gesture.y)>8)) gesture.moved = true;
  },{capture:true,passive:true});
  const endGesture = event => {
    if (gesture && (gesture.moved || event.type === 'pointercancel')) { blockedCard = gesture.card; blockedUntil = performance.now()+500; }
    gesture = null;
  };
  document.addEventListener('pointerup',endGesture,true);
  document.addEventListener('pointercancel',endGesture,true);
  document.addEventListener('click',event => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const target = event.target instanceof Element ? event.target : null;
    if (!target || target.closest('.qk-quick-view')) return;
    const card = target.closest('.qk-collections__card,product-card');
    const explicit = target.closest('[data-qk-open]');
    if (!card && !explicit) return;
    if (card === blockedCard && performance.now()<blockedUntil && !target.closest('button,input,select')) { event.preventDefault(); event.stopImmediatePropagation(); return; }
    if (!explicit && target.closest('button,input,label,select,slideshow-controls,qk-card-actions,.swatches')) return;
    const link = explicit || target.closest('a[href*="/products/"]') || card?.querySelector('a[href*="/products/"]');
    if (!link) return;
    const url = new URL(link.href,location.origin);
    if (url.origin !== location.origin || !url.pathname.includes('/products/')) return;
    event.preventDefault(); event.stopImmediatePropagation();
    openProduct(url.toString(),link);
  },true);
  document.addEventListener('change',event => {
    if (!event.target.matches('[data-qk-variant]')) return;
    const url = new URL(productURL,location.origin); url.searchParams.set('variant',event.target.value); productURL = url.toString(); loadProduct(productURL,true);
  });
  document.addEventListener('slideshow:select',event => {
    event.target.querySelectorAll('.qk-gallery-dots button').forEach((button,index) => button.setAttribute('aria-current',String(index === event.detail.index)));
  });
  const cartURL = path => new URL(path,new URL(document.getElementById('QkShoppingCopy').dataset.root,location.origin));
  let cartItems = null, cartRevision = 0, cartSnapshot = null, cartReadAt = 0;
  const syncBagAction = actions => {
    const button = actions.querySelector('[data-qk-add-form] button');
    if (!button || !cartItems) return;
    const inBag = cartItems.some(item => String(item.variant_id) === actions.dataset.variantId && item.quantity > 0);
    if (inBag) button.dataset.added = 'true';
    else delete button.dataset.added;
    button.setAttribute('aria-pressed',String(inBag));
    button.setAttribute('aria-label',inBag ? actions.dataset.removeLabel : actions.dataset.addLabel);
    button.title = text(inBag ? 'remove_from_bag' : 'add_to_cart');
    if (!button.hasAttribute('aria-busy') && !button.dataset.celebrating) button.disabled = !inBag && actions.dataset.variantAvailable === 'false';
  };
  const syncCart = cart => {
    if (!Array.isArray(cart?.items)) return;
    cartRevision++; cartItems = cart.items;
    cartSnapshot = typeof cart.item_count === 'number' ? cart : null;
    cartReadAt = cartSnapshot ? Date.now() : 0;
    document.querySelectorAll('qk-card-actions').forEach(syncBagAction);
  };
  const readCart = async () => {
    const revision = cartRevision;
    const response = await fetch(cartURL('cart.js'),{cache:'no-store',headers:{Accept:'application/json'}});
    if (!response.ok) throw new Error('Cart request failed');
    const cart = await response.json();
    if (revision === cartRevision) syncCart(cart);
    return cart;
  };
  if (!customElements.get('qk-card-actions')) customElements.define('qk-card-actions',class extends HTMLElement { connectedCallback() { syncBagAction(this); } });
  document.addEventListener('cart:update',event => {
    if (Array.isArray(event.detail?.resource?.items) && typeof event.detail.resource.item_count === 'number') syncCart(event.detail.resource);
    else { cartSnapshot = null; readCart().catch(() => {}); }
  });
  window.addEventListener('pageshow',event => { if (event.persisted) readCart().catch(() => {}); });
  window.addEventListener('focus',() => { cartSnapshot = null; readCart().catch(() => {}); });
  readCart().catch(() => {});
  const celebrateBag = async button => {
    const packing = button.querySelector('.qk-bag-packing');
    if (packing && button.isConnected && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      await new Promise(resolve => {
        const finish = () => {
          clearTimeout(timeout);
          packing.removeEventListener('animationend',onEnd);
          delete button.dataset.celebrating;
          resolve();
        };
        const onEnd = event => { if (event.target === packing && event.animationName === 'qk-bag-pack') finish(); };
        const timeout = setTimeout(finish,1750);
        packing.addEventListener('animationend',onEnd);
        button.dataset.celebrating = 'true';
      });
    }
    syncBagAction(button.closest('qk-card-actions'));
  };
  let cartBusy = false;
  document.addEventListener('submit',async event => {
    const form = event.target;
    if (!form.matches('[data-qk-add-form]')) return;
    event.preventDefault(); event.stopImmediatePropagation();
    if (cartBusy || !form.checkValidity()) return;
    const button = form.querySelector('button[type="submit"]');
    if (button.disabled) return;
    const removing = button.dataset.added === 'true';
    if (removing) delete button.dataset.celebrating;
    cartBusy = true; button.disabled = true; button.setAttribute('aria-busy','true');
    const actions = form.closest('qk-card-actions');
    const status = actions.querySelector('[role="status"]');
    status.hidden = true; status.classList.remove('visually-hidden');
    let changed = false;
    try {
      const { CartAddEvent, CartUpdateEvent } = await import('@theme/events');
      const beforeCart = cartSnapshot && Date.now() - cartReadAt < 5000 ? cartSnapshot : await readCart();
      const matchingItems = beforeCart.items.filter(item => String(item.variant_id) === actions.dataset.variantId);
      if ((removing && !matchingItems.length) || (!removing && matchingItems.length)) {
        status.textContent = text(removing ? 'removed' : 'added'); status.classList.add('visually-hidden'); status.hidden = false;
        return;
      }
      const body = new FormData(form);
      const sectionIds = [...new Set([...document.querySelectorAll('cart-items-component[data-section-id]')].map(el => el.dataset.sectionId))].slice(0,5);
      if (sectionIds.length) body.set('sections',sectionIds.join(','));
      body.set('sections_url',location.pathname);
      const updates = Object.fromEntries(matchingItems.map(item => [item.key,0]));
      const response = removing
        ? await fetch(cartURL('cart/update.js'),{method:'POST',body:JSON.stringify({updates,sections:sectionIds,sections_url:location.pathname}),headers:{Accept:'application/json','Content-Type':'application/json'}})
        : await fetch(form.action+'.js',{method:'POST',body,headers:{Accept:'application/json'}});
      const result = await response.json();
      if (!response.ok || result.status) {
        cartSnapshot = null;
        status.textContent = typeof result.description === 'string' ? result.description : text(removing ? 'remove_error' : 'add_error'); status.hidden = false; return;
      }
      changed = true;
      status.textContent = text(removing ? 'removed' : 'added'); status.classList.add('visually-hidden'); status.hidden = false;
      let cart;
      if (removing) { cart = result; syncCart(cart); }
      else {
        const addedItems = result.items || [result];
        const addedKeys = new Set(addedItems.map(item => item.key));
        syncCart({items:[...beforeCart.items.filter(item => !addedKeys.has(item.key)),...addedItems]});
      }
      const CartEvent = removing ? CartUpdateEvent : CartAddEvent;
      document.dispatchEvent(new CartEvent(cart,actions.dataset.productId,{source:cart?'qk-quick-shop':'product-form-component',productId:actions.dataset.productId,itemCount:cart?.item_count ?? Number(body.get('quantity')||1),sections:result.sections}));
      button.removeAttribute('aria-busy');
      if (!removing && dialog?.open && dialog.contains(form)) close();
      else if (!removing) celebrateBag(button).catch(() => {});
    } catch {
      cartSnapshot = null;
      status.textContent = changed ? text('cart_refresh_error') : text(removing ? 'remove_error' : 'add_error'); status.classList.remove('visually-hidden'); status.hidden = false;
    } finally { cartBusy = false; button.removeAttribute('aria-busy'); button.disabled = false; syncBagAction(actions); }
  },true);
  let navigationLink, navigationTimer;
  const clearNavigation = () => {
    clearTimeout(navigationTimer);
    document.documentElement.classList.remove('qk-navigation-pending');
    navigationLink?.removeAttribute('aria-busy');
    navigationLink?.removeAttribute('data-qk-navigating');
    navigationLink = null;
  };
  window.addEventListener('pageshow', clearNavigation);
  document.addEventListener('click', event => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link = event.target.closest?.('.menu-drawer a[href], .mega-menu a[href], .qk-shop-switch a[href], .qk-collection-nav a[href]');
    if (!link || link.hasAttribute('download') || (link.target && link.target !== '_self')) return;
    const destination = new URL(link.href, location.href);
    if (destination.origin !== location.origin || destination.protocol !== location.protocol) return;
    if (destination.pathname === location.pathname && destination.search === location.search) return;
    clearNavigation();
    navigationLink = link;
    link.setAttribute('aria-busy', 'true');
    link.setAttribute('data-qk-navigating', 'true');
    document.documentElement.classList.add('qk-navigation-pending');
    navigationTimer = setTimeout(clearNavigation, 15000);
  });

}
  } catch(e) { console.error(e); }
})();

})();
